import Box from "ds/components/Box";
import Typography from "ds/components/Typography";

import { VariableCellComponentProps } from "./types";

const SecretCell = ({ variable }: VariableCellComponentProps) => {
  return (
    <Box align="center">
      <Typography variant="p-body3" tag="span">
        {variable.writeOnly ? "Secret" : "Plain"}
      </Typography>
    </Box>
  );
};

export default SecretCell;
